import { put, call, takeLatest, select } from 'redux-saga/effects';
import _ from 'lodash';
import { showMessage } from 'utils/helpers';

import { request } from 'api';
import { TYPE, ACTION } from './actions';
import * as selectors from './selectors';

function* fetchFopsHandler() {
    try {
        yield put(ACTION.fetchFopsLoading());

        const res = yield call(request, 'account-admin/fop');

        yield put(ACTION.fetchFopsSuccess(res.data));
    } catch (err) {
        yield put(ACTION.fetchFopsError(err));
        console.error('fetchFopsHandler', err);
    }
}

function* prepareFilter() {
    try {
        const res = yield call(request, 'account-admin/fop');
        const filtersData = _.get(res, 'data', []);
        yield put(ACTION.prepareFilterSuccess(filtersData));
    } catch (err) {
        console.error('Failed to prepare automaton filter');
    }
}

function* editFopHandler({ payload }) {
    try {
        if (payload.new) {
            yield put(ACTION.toggleEditModal({ active: true, data: payload }));
        } else {
            const fop = yield select(selectors.getFopById(payload.id));

            if (!fop) {
                throw new Error('Edit: Chosen fop not found.');
            } else {
                yield put(ACTION.toggleEditModal({ active: true, data: fop }));
            }
        }
    } catch (err) {
        console.error('editFopHandler', err);
    }
}

function* submitEditHandler({ payload = {} }) {
    try {
        const body = {
            name: payload.name,
        };
        const isNew = yield select(selectors.isNewModal('editFop'));

        if (isNew) {
            yield call(request, {
                method: 'POST',
                url: 'account-admin/fop',
                data: body
            });
            showMessage({ message: 'Створено ФОП:', description: payload.name, type: 'success' });
        } else {
            const editedFop = yield select(selectors.getModalData('editFop'));
            if (!editedFop) {
                throw new Error('Failed to get modal data!');
            }
            body.id = editedFop.id;
            yield call(request, {
                method: 'PUT',
                url: `account-admin/fop`,
                data: body
            });
            showMessage({ message: 'Відредаговано успішною', type: 'success' });
        }

        yield put(ACTION.toggleEditModal({ active: false, data: {} }));
        yield put(ACTION.fetchFops());
        yield put(ACTION.prepareFilter());
    } catch (err) {
        console.error('submitEditHandler', err);
    }
}

export default [
    takeLatest(TYPE.FETCH_FOPS, fetchFopsHandler),
    takeLatest(TYPE.EDIT, editFopHandler),
    takeLatest(TYPE.SUBMIT_EDIT, submitEditHandler),
    takeLatest(TYPE.PREPARE_FILTER, prepareFilter),
];
